// Mock data for AU YH Care website

export const companyInfo = {
  name: "AU YH CARE PTY LTD",
  chineseName: "澳家居家养老",
  tagline: "Australian Home Care",
  abn: "59 690 875 426",
  location: "22 Cambridge St, Epping NSW 2121",
  phone: "0433 610 209",
  phoneRaw: "0433610209",
  email: "oliver@auyhcare.com",
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_auyh-care/artifacts/kegmgrow_2BE5FE48-24BB-4579-B202-2C3320F08A63.jpeg",
  wechat: "auyhcare",
  wechatQR: "https://customer-assets-lqy194kg.emergentagent.net/job_auyh-care/artifacts/y5acfv3q_IMG_6889.jpeg",
  whatsapp: "+61 433 610 209"
};

export const statistics = [
  { number: "100+", label: "Families Supported", labelZh: "服务家庭" },
  { number: "Bilingual", label: "English & Chinese", labelZh: "中英双语" },
  { number: "Sydney", label: "Local & Trusted", labelZh: "本地信赖" },
  { number: "Associated", label: "Aged Care Provider", labelZh: "关联养老服务商" }
];

export const trustBadges = [
  { title: "Associated Aged Care Provider", titleZh: "关联养老服务商" },
  { title: "Bilingual Workforce", titleZh: "双语团队" },
  { title: "Police Checked", titleZh: "警察背景调查" },
  { title: "Fully Insured", titleZh: "全额保险" }
];

export const heroContent = {
  title: "Compassionate Care in the Comfort of Home",
  titleZh: "在家享受充满关怀的专业照护",
  subtitle: "Professional aged care services delivered with warmth, dignity and respect across NSW",
  subtitleZh: "在新南威尔士州提供温暖、尊严和尊重的专业养老护理服务",
  cta: "Get Started",
  ctaZh: "开始咨询",
  image: "https://images.unsplash.com/photo-1774094135149-bbeeb1767bfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxhc2lhbiUyMGVsZGVybHklMjBjYXJlZ2l2ZXJ8ZW58MHx8fHwxNzg0NzE5MzU5fDA&ixlib=rb-4.1.0&q=85"
};

export const services = [
  {
    id: 0,
    number: "00",
    title: "My Aged Care Concierge",
    titleZh: "养老护理申请协助服务",
    description: "End-to-end assistance with My Aged Care registration, assessment booking, status tracking and post-approval scheduling. One bilingual case manager walks you through every step.",
    descriptionZh: "从注册到批准，提供全程双语协助。包括My Aged Care登记、评估预约、进度跟踪和批准后安排。一位双语个案经理全程陪伴您完成每一步。",
    image: "https://images.unsplash.com/photo-1623764410283-b45aeaacfd5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxhc2lhbiUyMGVsZGVybHklMjBjYXJlZ2l2ZXJ8ZW58MHx8fHwxNzg0NzE5MzU5fDA&ixlib=rb-4.1.0&q=85",
    features: [
      "My Aged Care registration",
      "Assessment coordination",
      "Status tracking",
      "Bilingual support"
    ],
    featuresZh: [
      "My Aged Care注册",
      "评估协调",
      "进度跟踪",
      "双语支持"
    ]
  },
  {
    id: 1,
    number: "01",
    title: "Personal Care",
    titleZh: "个人护理",
    description: "Assistance with daily living activities including showering, dressing, grooming, and medication management. Delivered with respect and dignity.",
    descriptionZh: "协助日常生活活动，包括洗澡、穿衣、梳洗和药物管理。以尊重和尊严的方式提供服务。",
    image: "https://images.pexels.com/photos/5692699/pexels-photo-5692699.jpeg",
    features: ["Hygiene assistance", "Medication support", "Mobility support", "Continence care"],
    featuresZh: ["卫生协助", "药物支持", "移动协助", "失禁护理"]
  },
  {
    id: 2,
    number: "02",
    title: "Domestic Assistance",
    titleZh: "家务协助",
    description: "Help with household tasks to maintain a clean, safe, and comfortable home environment.",
    descriptionZh: "协助家务，保持清洁、安全和舒适的家居环境。",
    image: "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408",
    features: ["Light housekeeping", "Meal preparation", "Laundry services", "Shopping assistance"],
    featuresZh: ["轻度家务", "餐食准备", "洗衣服务", "购物协助"]
  },
  {
    id: 3,
    number: "03",
    title: "Companionship & Social Support",
    titleZh: "陪伴与社交支持",
    description: "Meaningful connection and engagement to combat isolation and promote wellbeing.",
    descriptionZh: "有意义的联系和参与，对抗孤独，促进健康。",
    image: "https://images.unsplash.com/photo-1591688535138-8b1995fe8891",
    features: ["Social activities", "Conversation & company", "Community access", "Cultural support"],
    featuresZh: ["社交活动", "对话与陪伴", "社区参与", "文化支持"]
  },
  {
    id: 4,
    number: "04",
    title: "Nursing & Clinical Care",
    titleZh: "护理与临床护理",
    description: "Professional nursing services for complex health needs, delivered by registered nurses.",
    descriptionZh: "由注册护士提供专业护理服务，满足复杂健康需求。",
    image: "https://images.pexels.com/photos/20850801/pexels-photo-20850801.jpeg",
    features: ["Medication management", "Wound care", "Health monitoring", "Chronic disease support"],
    featuresZh: ["药物管理", "伤口护理", "健康监测", "慢性病支持"]
  },
  {
    id: 5,
    number: "05",
    title: "Transport & Mobility",
    titleZh: "交通与移动协助",
    description: "Safe transportation and mobility assistance to maintain independence and community connections.",
    descriptionZh: "安全的交通和移动协助，保持独立性和社区联系。",
    image: "https://images.unsplash.com/photo-1773227055624-07b515ba87c5",
    features: ["Medical appointments", "Social outings", "Shopping trips", "Mobility aid support"],
    featuresZh: ["医疗预约", "社交外出", "购物出行", "移动辅助支持"]
  }
];

export const fundingLevels = [
  {
    level: 1,
    name: "Minimal Support",
    nameZh: "最低支持",
    code: "L1",
    description: "Light, occasional help to stay safe and confident at home",
    descriptionZh: "轻度、偶尔的帮助，让您在家安全自信",
    amount: "$10,732",
    period: "per year",
    periodZh: "每年"
  },
  {
    level: 2,
    name: "Light Personal Care",
    nameZh: "轻度个人护理",
    code: "L2",
    description: "Regular help with showering, dressing and meals a few times a week",
    descriptionZh: "每周几次定期协助洗澡、穿衣和餐食",
    amount: "$16,035",
    period: "per year",
    periodZh: "每年"
  },
  {
    level: 3,
    name: "Moderate Support",
    nameZh: "中度支持",
    code: "L3",
    description: "Balanced mix of personal care, transport and domestic support several times each week",
    descriptionZh: "每周多次个人护理、交通和家务支持的均衡组合",
    amount: "$21,966",
    period: "per year",
    periodZh: "每年"
  },
  {
    level: 4,
    name: "High-frequency Support",
    nameZh: "高频率支持",
    code: "L4",
    description: "Daily personal care plus weekly nursing or therapy visits",
    descriptionZh: "每日个人护理加每周护理或治疗访问",
    amount: "$29,696",
    period: "per year",
    periodZh: "每年"
  },
  {
    level: 5,
    name: "Daily Support & Health Coordination",
    nameZh: "每日支持与健康协调",
    code: "L5",
    description: "Comprehensive daily care with active health coordination",
    descriptionZh: "全面的每日护理与积极的健康协调",
    amount: "$39,697",
    period: "per year",
    periodZh: "每年"
  },
  {
    level: 6,
    name: "Comprehensive Care",
    nameZh: "全面护理",
    code: "L6",
    description: "Multiple daily visits with nursing oversight and respite for family carers",
    descriptionZh: "每日多次访问，护理监督和家庭护理者的喘息服务",
    amount: "$48,113",
    period: "per year",
    periodZh: "每年"
  },
  {
    level: 7,
    name: "Intensive Daily Care",
    nameZh: "密集每日护理",
    code: "L7",
    description: "Intensive daily clinical and personal care for advanced conditions",
    descriptionZh: "针对晚期病况的密集每日临床和个人护理",
    amount: "$58,147",
    period: "per year",
    periodZh: "每年"
  },
  {
    level: 8,
    name: "Highest Level of Care",
    nameZh: "最高级别护理",
    code: "L8",
    description: "The most intensive in-home support available, comparable to residential aged care",
    descriptionZh: "最密集的居家支持服务，相当于养老院护理级别",
    amount: "$78,106",
    period: "per year",
    periodZh: "每年"
  }
];

export const applicationJourney = [
  {
    step: 1,
    title: "Apply",
    titleZh: "申请",
    day: "Day 1",
    dayZh: "第1天",
    description: "AU YH Care assists you to register with My Aged Care and submit the assessment request.",
    descriptionZh: "AU YH Care协助您注册My Aged Care并提交评估申请。"
  },
  {
    step: 2,
    title: "Information Check",
    titleZh: "信息核查",
    day: "~2 weeks",
    dayZh: "约2周",
    description: "My Aged Care calls to verify your details and refers you to an assessment provider.",
    descriptionZh: "My Aged Care致电核实您的详细信息并转介至评估服务商。"
  },
  {
    step: 3,
    title: "Home Assessment",
    titleZh: "居家评估",
    day: "4-6 weeks",
    dayZh: "4-6周",
    description: "The assessment provider books a time and conducts the in-home assessment.",
    descriptionZh: "评估服务商预约时间并进行居家评估。"
  },
  {
    step: 4,
    title: "Result",
    titleZh: "结果",
    day: "Within 2 weeks",
    dayZh: "2周内",
    description: "Result becomes available online and a letter is mailed to your home.",
    descriptionZh: "结果在线可查，并会邮寄信件到您家中。"
  },
  {
    step: 5,
    title: "Wait for Funding",
    titleZh: "等待资金",
    day: "7-10 months",
    dayZh: "7-10个月",
    description: "My Aged Care releases funding through the National Priority System.",
    descriptionZh: "My Aged Care通过国家优先系统发放资金。"
  },
  {
    step: 6,
    title: "Service Start",
    titleZh: "服务开始",
    day: "Once code arrives",
    dayZh: "收到代码后",
    description: "Once your activation code arrives and the service agreement is signed, AU YH Care designs your personalised Care Plan.",
    descriptionZh: "一旦您收到激活代码并签署服务协议，AU YH Care将为您设计个性化护理计划。"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Margaret L.",
    location: "Epping, NSW",
    quote: "The care team has been wonderful. They treat my mother with such respect and kindness. We finally have peace of mind.",
    quoteZh: "护理团队非常出色。他们对我母亲充满尊重和善意。我们终于可以安心了。",
    rating: 5
  },
  {
    id: 2,
    name: "David Chen",
    nameZh: "陈大卫",
    location: "Ryde, NSW",
    quote: "Professional, reliable, and genuinely caring. AU YH Care has made it possible for Dad to stay in his own home safely.",
    quoteZh: "专业、可靠、真诚关怀。AU YH Care让父亲能够安全地留在自己家中。",
    rating: 5
  },
  {
    id: 3,
    name: "Sarah K.",
    location: "Carlingford, NSW",
    quote: "From the first assessment to ongoing care, the team has been exceptional. Highly recommend their services.",
    quoteZh: "从首次评估到持续护理，团队表现卓越。强烈推荐他们的服务。",
    rating: 5
  }
];


// Additional exports for backward compatibility
export const contactReasons = [
  "Request a care assessment",
  "Enquire about services",
  "Discuss funding options",
  "Speak with our team",
  "Other enquiry"
];

export const manifestoPoints = [
  {
    number: "01",
    title: "Person-Centred Care",
    description: "Every individual deserves care tailored to their unique needs, preferences, and dignity. We listen, understand, and adapt."
  },
  {
    number: "02",
    title: "Home is Where the Heart Is",
    description: "Supporting independence in familiar surroundings. Your home, your comfort, your choice."
  },
  {
    number: "03",
    title: "Professional Excellence",
    description: "Qualified, experienced caregivers committed to the highest standards of aged care service delivery."
  },
  {
    number: "04",
    title: "Trust & Transparency",
    description: "Clear communication, reliable service, and genuine care that families can depend on."
  }
];

export const fundingPrograms = [
  {
    id: 1,
    title: "Support at Home (SAH) Program",
    description: "The new unified aged care program replacing Commonwealth Home Support Programme (CHSP) and Home Care Packages from July 2025.",
    eligibility: [
      "Aged 65 years or older (50+ for Aboriginal and Torres Strait Islander peoples)",
      "Australian citizen or permanent resident",
      "Assessed by Aged Care Assessment Team (ACAT)",
      "Living at home and requiring support services"
    ],
    benefits: [
      "Single streamlined program",
      "Flexible support levels",
      "Choice and control over services",
      "Government subsidised care"
    ]
  },
  {
    id: 2,
    title: "Home Care Packages (HCP)",
    description: "Coordinated packages of care services for older Australians with more complex care needs (transitioning to SAH).",
    levels: [
      "Level 1: Basic care needs",
      "Level 2: Low level care needs",
      "Level 3: Intermediate care needs",
      "Level 4: High level care needs"
    ],
    note: "HCP is transitioning to Support at Home. Current package holders can continue services during transition."
  }
];
